import React, { FC } from 'react';

import { Table } from 'antd';

import { Link } from 'react-router-dom';

interface Plan {
  plan_number: number;
  producer_first_name: string;
  producer_last_name: string;
  purchaser_first_name: string;
  purchaser_last_name: string;
  purchaser_email: string;
  business_name: string;
  date_quoted: string;
  date_placed: string | null;
  term_end: string;
  status: string;
  current_premium: number;
  paid_premium: number;
  total_premium: string;
  commission_ytd: number;
  total_commission: number;
}

interface PlansTableProps {
  tableData: Plan[];
}

const PlansTable: FC<PlansTableProps> = ({ tableData }) => {
  const formatDate = (dateString: string | null) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString();
  };

  const formatCurrency = (amount: number | string) => {
    if (typeof amount === 'string') return amount;
    return `$${amount.toFixed(2)}`;
  };

  const columns = [
    {
      title: 'Producer',
      key: 'producer',
      render: (record: Plan) =>
        `${record.producer_first_name} ${record.producer_last_name}`,
    },
    {
      title: 'Purchaser',
      key: 'purchaser',
      render: (record: Plan) => (
        <div>
          <div>{`${record.purchaser_first_name} ${record.purchaser_last_name}`}</div>
          <div>{record.purchaser_email}</div>
        </div>
      ),
    },
    {
      title: 'Business Name',
      dataIndex: 'business_name',
      key: 'business_name',
    },
    {
      title: 'Plan Number',
      dataIndex: 'plan_number',
      key: 'plan_number',
      render: (text: number) => (
        <Link to={`/affiliate/plan-terms/${text}`}>{text}</Link>
      ),
    },
    {
      title: 'Dates',
      key: 'dates',
      render: (record: Plan) => (
        <div>
          <div>Quoted: {formatDate(record.date_quoted)}</div>
          <div>Placed: {formatDate(record.date_placed)}</div>
          <div>End: {formatDate(record.term_end)}</div>
        </div>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Premiums',
      key: 'premiums',
      render: (record: Plan) => (
        <div>
          <div>Current: {formatCurrency(record.current_premium)}</div>
          <div>Paid: {formatCurrency(record.paid_premium)}</div>
          <div>Total: {formatCurrency(record.total_premium)}</div>
        </div>
      ),
    },
    {
      title: 'Commission',
      key: 'commission',
      render: (record: Plan) => (
        <div>
          <div>YTD: {formatCurrency(record.commission_ytd)}</div>
          <div>Total: {formatCurrency(record.total_commission)}</div>
        </div>
      ),
    },
  ];

  return (
    <Table
      dataSource={tableData}
      columns={columns}
      rowKey="plan_number"
      className="mx-8"
      pagination={{
        pageSize: 10,
        showTotal: (total) => `Total ${total} plans`,
      }}
      scroll={{ x: true }}
    />
  );
};

export default PlansTable;
